import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import RFQForm, { RFQSteps, familyToCategory } from '@/components/feature/RFQForm';
import { products } from '@/mocks/products';

export default function RequestQuotePage() {
  const [params] = useSearchParams();
  const slug = params.get('product') || '';
  const product = products.find((p) => p.slug === slug) || null;

  useEffect(() => {
    document.title = 'Request a Quote | NORTHLINE Flow Systems';
  }, []);

  return (
    <>
      <Navbar />
      <main className="bg-background-50 pt-16 md:pt-20">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-12 md:py-20">
          <nav aria-label="Breadcrumb" className="font-label text-xs tracking-[0.08em] text-foreground-500">
            <Link to="/" className="cursor-pointer hover:text-primary-500">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-950">Request a Quote</span>
          </nav>
          <header className="mt-10 md:mt-14">
            <p className="eyebrow text-primary-500">Request a Quote</p>
            <h1 data-mo="title" data-mo-now className="mt-5 h-section text-foreground-950 max-w-4xl">TELL US WHAT YOUR LINE NEEDS.</h1>
            <p className="mt-5 t-body text-foreground-600 max-w-xl">Share your requirements. We&apos;ll help identify suitable components and quotation options.</p>
          </header>

          {product && (
            <div className="mt-12 md:mt-14 flex items-center gap-4 md:gap-6 py-5 border-y border-background-200">
              <div className="w-16 h-16 md:w-20 md:h-20 shrink-0 rounded-lg bg-background-100/70 flex items-center justify-center p-2">
                <img src={product.image} alt={`${product.name} - ${product.family}`} title={`${product.name} - NORTHLINE`} className="max-w-full max-h-full object-contain" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-label text-[10px] tracking-[0.16em] uppercase text-foreground-500">Selected product</p>
                <p className="mt-1 text-[15px] md:text-base font-medium text-foreground-950 truncate">{product.name}</p>
                <p className="text-xs md:text-sm text-primary-500">{product.family}</p>
              </div>
              <Link to="/products" className="shrink-0 font-label text-[11px] tracking-[0.12em] uppercase text-foreground-700 hover:text-primary-500 cursor-pointer whitespace-nowrap">
                <span className="hidden sm:inline">Change product</span><span className="sm:hidden">Change</span> <i className="ri-arrow-right-line" />
              </Link>
            </div>
          )}

          <RFQForm
            key={product?.slug || 'general'}
            formId="northline-quote-page-form"
            idPrefix="rq"
            defaultCategory={product ? familyToCategory(product.family) : ''}
            product={product ? { slug: product.slug, name: product.name } : null}
            className={product ? 'mt-10 md:mt-12' : 'mt-12 md:mt-16'}
          />
          <RFQSteps />
        </div>
      </main>
      <Footer />
    </>
  );
}